import React from "react";
import { Spinner, Container, Row, Col } from "react-bootstrap";

function Loading() {
  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="5">
            <div style={{ textAlign: "center", paddingTop: 100 }}>
              <Spinner size="sm" animation="grow" variant="secondary" />
              <Spinner size="sm" animation="grow" variant="secondary" />
              <Spinner size="sm" animation="grow" variant="secondary" />
              <Spinner size="sm" animation="grow" variant="secondary" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Loading;
